import { useEffect } from "react";
import "../scss/Faqs.scss";

interface FaqsProps {
  loaderStatus?: (status: boolean) => void;
}

const Faqs = ({ loaderStatus }: FaqsProps) => {
  // Static page: nothing to fetch, so clear the global loading overlay on mount.
  useEffect(() => {
    loaderStatus?.(true);
  }, [loaderStatus]);

  return (
    <>
        <div className="legal_page">
            <div className="container">
                <div className="legal_page_content">
                    <h2>Frequently Asked Questions (FAQs)</h2>

                    <h3>1. What is Sekho?</h3>
                    <p className="faq_text">
                      Sekho is a digital learning platform that provides educational, vocational, executive, and language-learning courses. It offers video lectures, quizzes, textbooks, PDF books and notes, and other learning content.
                    </p>

                    <h3>2. What type of learning content is available on Sekho?</h3>
                    <p className="faq_text">
                      Sekho provides content across educational learning, vocational and executive training, and language learning. The platform is designed to support exam preparation, professional development, skill building, and personal learning.
                    </p>

                    <h3>3. Does Sekho offer courses for school students?</h3>
                    <p className="faq_text">
                      Yes. Sekho provides learning content for students in Grades 1–12, including video lectures, quizzes, and textbooks to support exam preparation.
                    </p>

                    <h3>4. What are the popular categories on Sekho?</h3>
                    <p className="faq_text">
                      Sekho highlights educational courses, vocational and executive training, and language learning as key categories available on the platform.
                    </p>

                    <h3>5. What can I learn through Sekho?</h3>
                    <p className="faq_text">
                      You can use Sekho to prepare for academic exams, develop vocational and executive skills, learn languages, discover new hobbies, improve your professional profile, and work toward personal development goals.
                    </p>

                    <h3>6. What are the subscription prices?</h3>
                    <p>
                        <strong>Weekly Plans (Exclusive of Tax):</strong>
                    </p>
                    <ul>
                        <li>Basic — Rs. 50</li>
                        <li>Value — Rs. 70</li>
                        <li>Pro — Rs. 100</li>
                        <li>Ultra — Rs. 125</li>
                        <li>Premium — Rs. 150</li>
                    </ul>
                    <p>
                        <strong>Monthly Plans (Exclusive of Tax):</strong>
                    </p>
                    <ul>
                        <li>Elite Value — Rs. 360</li>
                        <li>Elite Pro — Rs. 460</li>
                        <li>Elite Premium — Rs. 560</li>
                        <li>Signature — Rs. 660</li>
                    </ul>

                    <h3>7. How can I subscribe to Sekho?</h3>
                    <p className="faq_text">To subscribe to Sekho:</p>
                    <ol>
                        <li>Visit the Sekho  web platform.</li>
                        <li>Click on &quot;Subscribe.&quot;</li>
                        <li>Enter your jazzcash MSISDN/mobile number.</li>
                        <li>You will be redirected to the JazzCash payment screen. </li>
                        <li>Enter your OTP and MPIN to securely link and authorize your JazzCash account.</li>
                        <li>Once the payment is successfully completed, your Sekho  subscription will be activated.</li>
                    </ol>

                    <h3>8. Can I download or record Sekho content?</h3>
                    <p className="faq_text">
                      No. Users are not permitted to download, copy, record, screenshot, reproduce, redistribute, or otherwise capture content available on the platform.
                    </p>
            
                    <h3>9. What should I do if my subscription payment fails?</h3>
                    <p className="faq_text">
                        If a subscription payment fails, the Billing Provider may retry the payment. If payment remains unsuccessful, access to premium content may be suspended until a successful payment is processed.
                    </p>

                    <h3>10. What should I do if I need help with Sekho?</h3>
                    <p className="faq_text">
                      For any questions, technical issues, or assistance related to your Sekho subscription, please contact our customer support team:
                    </p>
                    <p>
                        Email: <a href="mailto:support@celsius.cc">support@celsius.cc</a>
                    </p>
                </div>
            </div>
        </div>
    </>
  );
};
export default Faqs;
